import React from "react";

import { Component } from "../../../../commons/types/component";
import cn from "../../libs/class-name";

interface Props extends Component {
  children: React.ReactNode;
}

const AvailabilityList = ({ classNames = [], children }: Props) => (
  <div className={cn("AvailabilityList", [], classNames)}>{children}</div>
);

export default AvailabilityList;
